import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { RecordStatus } from "@/components/shared/entity/recordStatus";
import type { Language } from "@/domain/common";
import { CULTURAL_ACTIVITIES, type HubStatus, type InvestorType } from "@/domain/investor";
import { useLabelMap } from "@/presentation/hooks/useLabelMap";
import { INVESTOR_TYPES, LANGUAGES } from "../config/investorDisplay";

export function useInvestorLabels() {
  const { t } = useTranslation();
  const byValue = useLabelMap();
  return useMemo(() => {
    const statusLabels: Record<RecordStatus, string> = byValue(
      ["active", "inactive", "archived"],
      (value) => `record_status.${value}`,
    );
    const typeLabels: Record<InvestorType, string> = byValue(
      INVESTOR_TYPES,
      (value) => `investors.kind.${value}`,
    );
    const hubLabels: Record<HubStatus, string> = byValue(
      ["none", "pending", "active"],
      (value) => `investors.hub.${value}`,
    );
    const languageLabels: Record<Language, string> = byValue(
      LANGUAGES,
      (value) => `investors.languages.${value}`,
    );
    const interests = CULTURAL_ACTIVITIES.map((value) => ({
      value,
      label: t(`investors.interests.${value}`),
    }));
    return { statusLabels, typeLabels, hubLabels, languageLabels, interests };
  }, [byValue, t]);
}
